'use strict';

/**
 * @ngdoc type
 * @name mx.shell.ExtraPanelManager
 * @module mx.shell
 * @property {boolean} visible - shows whether ExtraPanel opened or close (use methods open()/close() to manage this state).
 * @property {mx.shell.View} view - contains current View in ExtraPanel (use method open(view) to change it).
 *
 * @description
 * .Extra Panel Manager allows to manage behaviour of Extra Panel.
 */
export class ExtraPanelManager {
	static $inject = ['mx.shell.EventService', '$timeout'];

	constructor(eventService, $timeout) {
		this.eventService = eventService;
		this.$timeout = $timeout;

		this.visible = false;
	}

	/**
	 * @ngdoc method
	 * @name mx.shell.ExtraPanelManager#open
	 *
	 * @description
	 * Opens ExtraPanel with passed View.
	 *
	 * @param {mx.shell.View} view - an instanse of mx.shell.View that should be shown in ExtraPanel
	 */
	open(view) {
		const stateChanged = this.visible !== true;
		this.visible = true;
		this.view = view;
		this.eventService.dispatchEvent(mx.shell.EventCodes.ExtraPanelOpened);
		if (stateChanged) {
			this.$timeout(() => this.eventService.dispatchEvent(mx.shell.EventCodes.LayoutChanged));
		}
	}

	/**
	 * @ngdoc method
	 * @name mx.shell.ExtraPanelManager#close
	 *
	 * @description
	 * Closes ExtraPanel.
	 */
	close($event) {
		const stateChanged = this.visible !== false;
		this.visible = false;
		this.view = undefined;
		this.eventService.dispatchEvent(mx.shell.EventCodes.ExtraPanelClosed, {
			$event: $event,
			closedByUser: $event && $event.currentTarget.className.split(' ').indexOf('mx-extra-panel--close') !== 0,
		});
		if (stateChanged) {
			this.$timeout(() => this.eventService.dispatchEvent(mx.shell.EventCodes.LayoutChanged));
		}
	}
}

angular.module('mx.shell').service('mx.shell.ExtraPanelManager', ExtraPanelManager);
